import { Auth } from '@prismamedia/one-components';

export const auth = new Auth(config.AUTH_API);

export const loginWithAzureIdToken = async (azureIdToken: string) => {
  const oneAuthBaseUrl = config.AUTH_API.replace(/\/$/, '');
  const response = await fetch(`${oneAuthBaseUrl}/azure-login`, {
    headers: new Headers({
      Authorization: `Bearer ${azureIdToken}`,
    }),
    mode: 'cors',
    cache: 'default',
  });
  const payload = await response.json();
  if (!response.ok || !payload.id_token) {
    throw new Error(payload.message || 'Erreur de connexion');
  }

  // Auth de one-components n'expose que login() sur /login : pas de setter public
  // pour un JWT ONE obtenu via un autre endpoint.
  ((auth as unknown) as { _setJwt: (token: string) => void })._setJwt(
    payload.id_token,
  );
  return payload.id_token as string;
};
